import React, { useState, useRef, useCallback } from 'react';
import { getConnections, connectionTone } from '../utils/connections';

// Inline SVG paths (same glyphs as assets/*Icon.svg) so `currentColor` drives the tint.
const WifiGlyph = ({ className }) => (
	<svg viewBox="0 0 24 17" className={className} fill="currentColor" aria-hidden="true">
		<path d="M11.9999 17C11.2999 17 10.7082 16.7583 10.2249 16.275C9.74152 15.7917 9.49985 15.2 9.49985 14.5C9.49985 13.8 9.74152 13.2083 10.2249 12.725C10.7082 12.2417 11.2999 12 11.9999 12C12.6999 12 13.2915 12.2417 13.7749 12.725C14.2582 13.2083 14.4999 13.8 14.4999 14.5C14.4999 15.2 14.2582 15.7917 13.7749 16.275C13.2915 16.7583 12.6999 17 11.9999 17ZM11.9999 6C13.2499 6 14.4375 6.2 15.5629 6.6C16.6882 7 17.7089 7.55 18.6249 8.25C18.9582 8.5 19.1292 8.82933 19.1379 9.238C19.1465 9.64667 19.0005 10.0007 18.6999 10.3C18.4165 10.5833 18.0665 10.7293 17.6499 10.738C17.2332 10.7467 16.8582 10.634 16.5249 10.4C15.8915 9.96667 15.1915 9.625 14.4249 9.375C13.6582 9.125 12.8499 9 11.9999 9C11.1499 9 10.3415 9.125 9.57485 9.375C8.80818 9.625 8.10818 9.96667 7.47485 10.4C7.14152 10.6333 6.76652 10.7417 6.34985 10.725C5.93318 10.7083 5.58318 10.5583 5.29985 10.275C5.01652 9.975 4.87485 9.621 4.87485 9.213C4.87485 8.805 5.04152 8.47567 5.37485 8.225C6.29152 7.525 7.31252 6.979 8.43785 6.587C9.56318 6.195 10.7505 5.99933 11.9999 6ZM11.9999 0C14.0832 0 16.0459 0.341667 17.8879 1.025C19.7299 1.70833 21.3839 2.675 22.8499 3.925C23.1832 4.20833 23.3582 4.55833 23.3749 4.975C23.3915 5.39167 23.2499 5.75 22.9499 6.05C22.6665 6.33333 22.3165 6.47933 21.8999 6.488C21.4832 6.49667 21.1082 6.36733 20.7749 6.1C19.5749 5.11667 18.2292 4.35433 16.7379 3.813C15.2465 3.27167 13.6672 3.00067 11.9999 3C10.3325 2.99933 8.75352 3.27033 7.26285 3.813C5.77218 4.35567 4.42618 5.118 3.22485 6.1C2.89152 6.36667 2.51652 6.496 2.09985 6.488C1.68318 6.48 1.33318 6.334 1.04985 6.05C0.749851 5.75 0.608184 5.39167 0.624851 4.975C0.641518 4.55833 0.816518 4.20833 1.14985 3.925C2.61652 2.675 4.27085 1.70833 6.11285 1.025C7.95485 0.341667 9.91718 0 11.9999 0Z" />
	</svg>
);

const CellularGlyph = ({ className }) => (
	<svg viewBox="0 0 16 12" className={className} fill="currentColor" aria-hidden="true">
		<path d="M14.75 11.5H13.25C13.0511 11.5 12.8603 11.421 12.7197 11.2803C12.579 11.1397 12.5 10.9489 12.5 10.75V1.25C12.5 1.05109 12.579 0.860322 12.7197 0.71967C12.8603 0.579018 13.0511 0.5 13.25 0.5H14.75C14.9489 0.5 15.1397 0.579018 15.2803 0.71967C15.421 0.860322 15.5 1.05109 15.5 1.25V10.75C15.5 10.9489 15.421 11.1397 15.2803 11.2803C15.1397 11.421 14.9489 11.5 14.75 11.5ZM10.75 11.5H9.25C9.05109 11.5 8.86032 11.421 8.71967 11.2803C8.57902 11.1397 8.5 10.9489 8.5 10.75V3.75C8.5 3.55109 8.57902 3.36032 8.71967 3.21967C8.86032 3.07902 9.05109 3 9.25 3H10.75C10.9489 3 11.1397 3.07902 11.2803 3.21967C11.421 3.36032 11.5 3.55109 11.5 3.75V10.75C11.5 10.9489 11.421 11.1397 11.2803 11.2803C11.1397 11.421 10.9489 11.5 10.75 11.5ZM6.75 11.5H5.25C5.05109 11.5 4.86032 11.421 4.71967 11.2803C4.57902 11.1397 4.5 10.9489 4.5 10.75V5.75C4.5 5.55109 4.57902 5.36032 4.71967 5.21967C4.86032 5.07902 5.05109 5 5.25 5H6.75C6.94891 5 7.13968 5.07902 7.28033 5.21967C7.42098 5.36032 7.5 5.55109 7.5 5.75V10.75C7.5 10.9489 7.42098 11.1397 7.28033 11.2803C7.13968 11.421 6.94891 11.5 6.75 11.5ZM2.75 11.5H1.25C1.05109 11.5 0.860322 11.421 0.71967 11.2803C0.579018 11.1397 0.5 10.9489 0.5 10.75V7.75C0.5 7.55109 0.579018 7.36032 0.71967 7.21967C0.860322 7.07902 1.05109 7 1.25 7H2.75C2.94891 7 3.13968 7.07902 3.28033 7.21967C3.42098 7.36032 3.5 7.55109 3.5 7.75V10.75C3.5 10.9489 3.42098 11.1397 3.28033 11.2803C3.13968 11.421 2.94891 11.5 2.75 11.5Z" />
	</svg>
);

const EthernetGlyph = ({ className }) => (
	<svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
		<path d="M7 15H9V18H11V15H13V18H15V15H17V18H19V9H15V6H9V9H5V18H7V15ZM4.38 3H19.63C19.9421 3 20.2511 3.06163 20.5393 3.18136C20.8275 3.30109 21.0892 3.47655 21.3094 3.69769C21.5296 3.91882 21.704 4.18127 21.8225 4.46997C21.941 4.75867 22.0013 5.06793 22 5.38V19.63C22 20.2586 21.7503 20.8614 21.3058 21.3058C20.8614 21.7503 20.2586 22 19.63 22H4.38C4.06793 22.0013 3.75867 21.941 3.46997 21.8225C3.18127 21.704 2.91882 21.5296 2.69769 21.3094C2.47655 21.0892 2.30109 20.8275 2.18136 20.5393C2.06163 20.2511 2 19.9421 2 19.63V5.38C2 4.06 3.06 3 4.38 3Z" />
	</svg>
);

const GLYPHS = { wifi: WifiGlyph, cellular: CellularGlyph, ethernet: EthernetGlyph };

// Icon colour by state. Grey = no internet (or unknown, older poseidon).
const TONE_CLASS = {
	primary: 'text-green-500',
	internet: 'text-blue-500',
	none: 'text-gray-400',
};

const TONE_LABEL = {
	primary: 'Primary',
	internet: 'Internet',
	none: 'No internet',
};

const TONE_BADGE = {
	primary: 'bg-green-100 text-green-800',
	internet: 'bg-blue-100 text-blue-700',
	none: 'bg-gray-100 text-gray-600',
};

// Size presets: card uses "md", list rows use "sm".
const SIZES = {
	sm: { icon: 'w-3 h-3', gap: 'gap-1' },
	md: { icon: 'w-5 h-5', gap: 'gap-2' },
};

const yesNo = (v) => (v === true ? 'Yes' : v === false ? 'No' : '—');

const PANEL_W = 288; // px, matches w-72

const ConnectionIcons = ({ versions, size = 'md', className = '' }) => {
	const [pos, setPos] = useState(null);
	const wrapRef = useRef(null);
	const connections = getConnections(versions);
	const sz = SIZES[size] || SIZES.md;
	const hasDetails = !!versions?.network;

	// Fixed positioning so the panel escapes overflow-hidden parents (list view table).
	const show = useCallback(() => {
		const el = wrapRef.current;
		if (!el) return;
		const r = el.getBoundingClientRect();
		const left = Math.max(8, Math.min(r.right - PANEL_W, window.innerWidth - PANEL_W - 8));
		setPos({ top: r.bottom + 6, left });
	}, []);
	const hide = useCallback(() => setPos(null), []);

	if (!connections.length) return null;

	return (
		<span
			ref={wrapRef}
			className={`relative inline-flex items-center ${sz.gap} ${className}`}
			onMouseEnter={show}
			onMouseLeave={hide}
			onFocus={show}
			onBlur={hide}
			tabIndex={0}
			aria-label="Network connections"
		>
			{connections.map((c) => {
				const Glyph = GLYPHS[c.kind];
				const tone = connectionTone(c);
				return (
					<Glyph
						key={`${c.kind}-${c.device}`}
						className={`${sz.icon} ${TONE_CLASS[tone]} transition-colors`}
					/>
				);
			})}

			{pos && (
				<div
					className="fixed z-[80] w-72 rounded-xl border border-gray-200 bg-white shadow-xl p-3 text-left cursor-default"
					style={{ top: pos.top, left: pos.left }}
					role="tooltip"
				>
					<p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-2">
						Connections
					</p>
					<ul className="divide-y divide-gray-200">
						{connections.map((c) => {
							const Glyph = GLYPHS[c.kind];
							const tone = connectionTone(c);
							return (
								<li key={`${c.kind}-${c.device}-row`} className="py-2 first:pt-0 last:pb-0">
									<div className="flex items-center gap-2">
										<Glyph className={`w-4 h-4 shrink-0 ${TONE_CLASS[tone]}`} />
										<span className="text-sm font-medium text-gray-900 truncate">{c.label}</span>
										<span className="text-xs text-gray-500 truncate">{c.device}</span>
										<span className={`ml-auto shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${TONE_BADGE[tone]}`}>
											{hasDetails ? TONE_LABEL[tone] : 'Connected'}
										</span>
									</div>
									{hasDetails && (
										<dl className="mt-1.5 grid grid-cols-3 gap-x-2 text-xs">
											<div>
												<dt className="text-gray-500">Metric</dt>
												<dd className="text-gray-900 font-medium tabular-nums">{c.metric ?? '—'}</dd>
											</div>
											<div>
												<dt className="text-gray-500">Primary</dt>
												<dd className="text-gray-900 font-medium">{yesNo(c.primary)}</dd>
											</div>
											<div>
												<dt className="text-gray-500">Internet</dt>
												<dd className="text-gray-900 font-medium">{yesNo(c.internet)}</dd>
											</div>
										</dl>
									)}
									{(c.ip || c.extra) && (
										<p className="mt-1 text-xs text-gray-500 truncate">
											{[c.extra, c.ip].filter(Boolean).join(' · ')}
										</p>
									)}
								</li>
							);
						})}
					</ul>
					{!hasDetails && (
						<p className="mt-2 text-[11px] text-gray-500">
							Update Poseidon to 1.2.1+ for primary / internet details.
						</p>
					)}
				</div>
			)}
		</span>
	);
};

export default ConnectionIcons;
